import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LabProvider } from "@/context/LabContext";
import { FeedbackProvider } from "@/context/FeedbackContext";
import Navbar from "@/components/Navbar";
import SiteFooter from "@/components/SiteFooter";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Lab from "@/pages/Lab";
import Dashboard from "@/pages/Dashboard";
import CheckIn from "@/pages/CheckIn";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App min-h-screen bg-[#FDFBF7]">
      <BrowserRouter>
        <AuthProvider>
          <LabProvider>
            <FeedbackProvider>
              <div className="flex flex-col min-h-screen">
                <Navbar />
                <div className="flex-1">
                  <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/login" element={<AuthPage mode="login" />} />
                    <Route path="/register" element={<AuthPage mode="register" />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route
                      path="/lab"
                      element={
                        <ProtectedRoute>
                          <Lab />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/dashboard"
                      element={
                        <ProtectedRoute>
                          <Dashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/checkin"
                      element={
                        <ProtectedRoute>
                          <CheckIn />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/admin"
                      element={
                        <ProtectedRoute>
                          <Admin />
                        </ProtectedRoute>
                      }
                    />
                  </Routes>
                </div>
                <SiteFooter />
              </div>
              <Toaster position="top-center" richColors />
            </FeedbackProvider>
          </LabProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
